<template>
  <div class="result-wrap">
    <img v-if="imgShow" src="@/assets/image/no-data.png">
    <div v-if="title&&tip" class="no_data_result">
      <div class="m3">{{ title }}</div>
      <div v-if="tip" class="m4">{{ tip }}</div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Result',
  props: {
    tip: {
      type: String,
      default() {
        return this.$t('message.m4')
      }
    },
    title: {
      type: String,
      default() {
        return this.$t('message.m3')
      }
    },
    imgShow: {
      type: Boolean,
      default() {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.result-wrap {
  @include flexC;
  flex-direction: column;
  padding: 20px 0;
  /* position: absolute;
  z-index: 2000;
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: opacity .3s; */
  img {
    width: 50%;
    min-width: 100px;
    max-width: 250px;
  }
  .no_data_result {
    width: 100%;
    text-align: center;
    color: #333;
    font-size: 13px;
    margin-top: 12px;
    .m3 {
      font-size: 16px;
    }
    .m4 {
      color: #999;
      margin-top: 10px;
    }
  }
  .tip{
    width: 100%;
    text-align: center;
    font-size: 20px;
    color: rgb(2, 125, 180);
  }
}
</style>
